import { render, staticRenderFns } from "./Clock.vue?vue&type=template&id=1494d16c&"
import script from "./Clock.vue?vue&type=script&lang=ts&"
export * from "./Clock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports